import React, { useEffect, useState } from 'react'
import { useParams, useHistory, withRouter, Redirect } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import ContactModal from '../../contacts/ContactModal'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { useDispatch, useSelector } from 'react-redux'
import { contactsActions } from '../../../../actions/contactsActions'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import {
  dateToDayMonthYearFormatted,
  formatDateForInput,
} from '../../../../utils/date'
import validators from '../../../../utils/validationsRegEx'

const EditCOntactDetails = () => {
  const { id } = useParams() //Este es el id_Contacto
  const history = useHistory()
  const dispatch = useDispatch()

  const hospitalContacts = useSelector((state) => state.hospitalsContacts)
  const businessunits = useSelector((state) => state.businessunits)
  const userProfile = useSelector((state) => state.userProfile)

  const updateContactDetails = (contact) =>
    dispatch(contactsActions.updateContact(contact))
  const updateHospitalContactDetails = (contact) =>
    dispatch(hospitalsContactsActions.updateContactDetails(contact))
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  const [isDisable, setIsDisable] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto

  const [inputs, setinputs] = useState({
    id_Contacto: id,
    nombre: '',
    telf: '',
    observaciones: '',
    email: '',
    fechaNacimiento: '',
    Telefono: '',
    id_Evento: '', // Agregado para consistencia con el modal
    businessUnits: [],
    id_Hospitales: null,
    id_Departamentos: null,
    id_Especialidades: null,
    id_TipoCargo: null,
  })

  const closeModal = () => {
    setModalIsOpen(false)
    history.goBack() // Regresa a la página anterior cuando se cierra con X
  }

  const closeModalAfterSave = () => {
    setModalIsOpen(false)
    history.push(routes.CONTACT_DETAIL + id) // Va al detalle después de guardar
  }

  useEffect(() => {
    getAllBusinessUnits()
  }, [])

  useEffect(() => {
    if (businessunits.length > 0 && hospitalContacts.length > 0) {
      getContactInfoById(id)
    }
  }, [id, businessunits, hospitalContacts])

  const getContactInfoById = async (idContact) => {
    try {
      const c = await hospitalContacts.find(
        (x) => x.id_Contacto.toString() === idContact,
      )

      if (c) {
        // Usar directamente los id_NegocioUnidades como businessUnits
        const contactBusinessUnits = c.id_NegocioUnidades || []

        setinputs((prevInputs) => ({
          ...prevInputs,
          ...c,
          Telefono: c.telf || c.Telefono,
          businessUnits: contactBusinessUnits,
          id_Departamentos: c.hospitalsContacts[0]?.id_TipoDepartamento,
          id_Especialidades: c.hospitalsContacts[0]?.id_TipoEspecialidad,
          id_Hospitales: c.hospitalsContacts[0]?.id_Hospital,
          id_TipoCargo: c.hospitalsContacts[0]?.id_TipoCargo,
          fechaNacimiento: c.fechaNacimiento
            ? formatDateForInput(c.fechaNacimiento)
            : '',
        }))
      }
    } catch (error) {
      toContacts()
    }
  }

  const handleSubmitToUpdateContact = async (event) => {
    event.preventDefault()
    
    setIsDisable(true)

    try {
      // businessUnits ya contiene los IDs directamente
      
      const { businessUnits, ...contactDataBase } = inputs

      const contactData = {
        ...contactDataBase,
        Telefono: inputs.telf,
        fechaNacimiento: dateToDayMonthYearFormatted(inputs.fechaNacimiento),
        id_NegocioUnidades: businessUnits || [],
        // Convertir a arrays como especifica el backend (int[])
        id_Hospitales: inputs.id_Hospitales
          ? [parseInt(inputs.id_Hospitales)]
          : [],
        id_Departamentos: inputs.id_Departamentos
          ? [parseInt(inputs.id_Departamentos)]
          : [],
        id_Especialidades: inputs.id_Especialidades
          ? [parseInt(inputs.id_Especialidades)]
          : [],
        id_TipoCargo: inputs.id_TipoCargo
          ? [parseInt(inputs.id_TipoCargo)]
          : [],
      }

      // const { businessUnits, ...contactDataBase } = inputs

      // const contactData = {
      //   ...contactDataBase
      // }

      const response = await updateContactDetails(contactData)
      const response2 = await updateHospitalContactDetails(response.payload)
      console.log("handleSubmitToUpdateContact", response2)
      // await updateHospitalContactDetails(contactData)


      swalSuccessGeneral(swalTitle.Actualizado)
      closeModalAfterSave() // Usar la función específica para después de guardar
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisable(false)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
    setinputs((inputs) => ({ ...inputs, Telefono: inputs.telf }))
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      ( !validators.hasValue(inputs.telf) || validators.phoneNumberFormat(inputs.telf) ) &&
      validators.emailFormat(inputs.email) &&
      inputs.businessUnits.length > 0 &&
      validators.hasValue(inputs.id_Especialidades) &&
      validators.hasValue(inputs.id_Hospitales) &&
      validators.hasValue(inputs.id_Departamentos) &&
      validators.hasValue(inputs.id_TipoCargo)
    )
  }

  const toContacts = () => {
    history.push(routes.CONTACTS)
  }

  return (
    <>
      {userProfile && userProfile.roles ? (
        <div className='products'>
          <ContactModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            inputs={inputs}
            handleChange={handleChange}
            handleSubmit={handleSubmitToUpdateContact}
            validateForm={validateForm}
            textBtn={onSubmitText.Guardar}
            businessunits={businessunits}
            isEdit={true}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(EditCOntactDetails)
